import React from "react";
import { Box, Paper, } from "@material-ui/core";
import { AdminLayout } from "frontend/src/pages/layouts";
import { MusicArchivesSearchResultTable } from "./ui/music-archives-search-result-table";
// import { PlaylistCreateNew } from "./ui/playlist-create-new";
import { useSearchTrackForm } from "./model/use-search-track-form";
export var MusicArchivesPage = function () {
    var _a = useSearchTrackForm(), search = _a.search, genres = _a.genres, form = _a.form;
    return (React.createElement(AdminLayout, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement("a", { href: "/admin/tracks/upload" }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u0440\u0435\u043A\u0438")),
        React.createElement(Box, { component: Paper, mt: 2 },
            React.createElement(MusicArchivesSearchResultTable, { params: form }))));
};
